// extracted by mini-css-extract-plugin
export var executiveTeamSection = "ExecutiveTeamNew-module--executiveTeamSection--dG-Dl";
export var sectionTitle = "ExecutiveTeamNew-module--sectionTitle--iJcnR";
export var teamGrid = "ExecutiveTeamNew-module--teamGrid--znqNP";